import React, { useState, useEffect, Children, useContext, useRef } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { eventService } from "../services/EventService";
import { Dialog } from "primereact/dialog";
import AddEvent from "../componets/AddEvent";
import EditEventDelimitation from "../componets/EditEventDelimitation";
import ByElections from "../componets/ByElections";
import { AppDB } from "../App";
import { delimitationService } from "../services/DelimitationService";
import ScreenLoader from "../componets/ScreenLoader";
import { BreadCrumb } from "primereact/breadcrumb";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import ReactDOM from "react-dom";
import TextInput from "../componets/TextInput";
import { EditUserGroup } from "./groups/EditUserGroup";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import AddSignature from "../componets/AddSignature";
import { permissionLookUp } from "./../constants";
import { changeLang } from "../componets/Language/ChangeLang";
import { data } from "jquery";
export function EventsTree({selectedEventGroup, showEvents, setShowEvents, setSelectedEventGroup, RefreshSelectedEventGroup}) {
	const [events, setEvents] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedEventDelimitation, setselectedEventDelimitation] = useState(null);
		const [isNational,setisNational] =useState(false)

	const [selectedEvent, setselectedEvent] = useState(null);
	const [selectedEventType, setselectedEventType] = useState(null);
	const [showAddEventForm, setshowAddEventForm] = useState(false);
	const [showPollingStationsForm, setShowPollingStationsForm] = useState(false);
	const [reason, setReason] = useState("");

	var [sortOptions, setSortOptions] = useState([
		{
			Name: "Surname",
			Value: "Surname"
		},
		{
			Name: "Firstname",
			Value: "Firstname"
		},
		{
			Name: "ID Number",
			Value: "IDNumber"
		},
		{
			Name: "Registration Number",
			Value: "RegistrationNumber"
		}
	]);
	const [pollingStationForm, setPollingStationForm] = useState({
		distributeRemainder: true,
		sortField: "Surname",
		sortOrderAscending: true,
		electorsPerPollingStation: 3,
		recreate: true,
		eventGroupId: selectedEventGroup?.eventGroupID
	});
	const [showEditEventDelimitationForm, setShowEditEventDelimitationForm] = useState(false);
	const [showByElectionEventForm, setShowByElectionEventForm] = useState(false);
	const { groupEventInfo, allEventsPerGroup, toast, permission } = useContext(AppDB);
	const [districtInfo, setdistrictInfo] = useState(null);
	const [selectedEventData, setselectedEventData] = useState(false);
	const [items, setItems] = useState([{ label: `Group : ${groupEventInfo.name}` }]);
		useEffect(() => {
		GetAllEvents();
	}, []);

	const handleDeactivate = (e) => {
		confirmDeleteEvent(e);
		setselectedEventData(e);
	};
	const footer = <div className="flex justify-content-start">{/* <Button icon="pi pi-refresh" label="Reload" severity="warning" /> */}</div>;

	const header = (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">Event Names</h5>
		</div>
	);

	function OnTreeExpand(event) {
		if (!event.node.children) {
			if (event.node.data.eventTypeID == 1 || event.node.data.eventTypeID == 4) {
				if(event.node.data.eventTypeID){
					setisNational(true)
				}
				//National election or referendum
				NationalDelimitationMain(event);
			} else if (event.node.data.eventTypeID == 2) {
				setisNational(false)
				LocalDelimitationMain(event);
			}
		}
	}
	function GetNationalDistricts(event) {
		setLoading(true);
		delimitationService
			.getDistricts()
			.then((response) => {
				setLoading(false);
				var districts = [];
				response.forEach((e) => {
					districts.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 1,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 1,
							levelName: changeLang.get("national_delimitation.district")
						},
						leaf: false
					});
				});

				const updatedEvents = events.map((node) => {
					if (node.key === event.node.key) {
						return {
							...node,
							children: [...(node.children || []), ...districts]
						};
					}
					return node;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => { setLoading(false);});
	}
	function GetNationalConstituencyByDistrictIdAsync(event) {
		setLoading(true);
		delimitationService
			.getConstituenciesByDistrict(event.node.data.eventDelimitationId)
			.then((response) => {
				var constituencies = [];
				setLoading(false);
				response.forEach((e) => {
					constituencies.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 2,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 2,
							levelName: changeLang.get("national_delimitation.constituency")
						},
						leaf: false
					});
				});

				var parentEventKey = event.node.key.split("-")[0];
				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEventKey) {
						const updatedChildren = eventItem.children.map((node) => {
							if (node.key == event.node.key) {
								return {
									...node,
									children: [...(node.children || []), ...constituencies]
								};
							}
							return node;
						});

						return {
							...eventItem,
							children: updatedChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function GetVotingDistrictByConstituency(event) {
		setLoading(true);
		delimitationService
			.getPollingDivisionsByConstituency(event.node.data.eventDelimitationId)
			.then((response) => {
				setLoading(false);
				var votingDistricts = [];
				response.forEach((e) => {
					votingDistricts.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 3,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 3,
							levelName: changeLang.get("national_delimitation.electoralDivision")
						},
						leaf: false
					});
				});

				var keys = event.node.key.split("-");
				var parentEvent = events.find((x) => x.key == keys[0]); // Find the parent event
				var districtNode = parentEvent.children.find((x) => x.key == `${keys[0]}-${keys[1]}`); // Find the district node

				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEvent.key) {
						const updatedDistrictChildren = eventItem.children.map((node) => {
							if (node.key == districtNode.key) {
								const updatedChildren = node.children.map((childNode) => {
									if (childNode.key == event.node.key) {
										return {
											...childNode,
											children: [...(childNode.children || []), ...votingDistricts]
										};
									}
									return childNode;
								});

								return {
									...node,
									children: updatedChildren
								};
							}
							return node;
						});

						return {
							...eventItem,
							children: updatedDistrictChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function GetVotingStationByVotingDistrictID(event) {
		setLoading(true);
		delimitationService
			.getRegistrationCentresByPollingDivision(event.node.data.eventDelimitationId)
			.then((response) => {
				setLoading(false);
				var VotingStation = [];
				response.forEach((e) => {
					VotingStation.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 4,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 4,
							levelName: changeLang.get("national_delimitation.votingCentre")
						},
						leaf: false
					});
				});

				var keys = event.node.key.split("-");
				var parentEvent = events.find((x) => x.key == keys[0]);
				var districtNode = parentEvent.children.find((x) => x.key == `${keys[0]}-${keys[1]}`);
				var constituencyNode = districtNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}`);

				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEvent.key) {
						const updatedDistrictChildren = eventItem.children.map((district) => {
							if (district.key == districtNode.key) {
								const updatedConstituencyChildren = district.children.map((constituency) => {
									if (constituency.key == constituencyNode.key) {
										const updatedChildNodes = constituency.children.map((node) => {
											if (node.key == event.node.key) {
												return {
													...node,
													children: [...(node.children || []), ...VotingStation]
												};
											}
											return node;
										});

										return {
											...constituency,
											children: updatedChildNodes
										};
									}
									return constituency;
								});

								return {
									...district,
									children: updatedConstituencyChildren
								};
							}
							return district;
						});
						return {
							...eventItem,
							children: updatedDistrictChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function GetPollingStaionByNationalVotingStation(event) {
		setLoading(true);
		delimitationService
			.getPollingStaionByNationalVotingStation(event.node.data.eventDelimitationId)
			.then((response) => {
				setLoading(false);
				var pollingStations = [];
				response.forEach((e) => {
					pollingStations.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 6,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 6,
							levelName: changeLang.get("national_delimitation.votingStation")
						},
						leaf: true
					});
				});

				var keys = event.node.key.split("-");
				var parentEvent = events.find((x) => x.key == keys[0]);
				var districtNode = parentEvent.children.find((x) => x.key == `${keys[0]}-${keys[1]}`);
				var constituencyNode = districtNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}`);
				var votingDistrictNode = constituencyNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}-${keys[3]}`);
				var votingStationNode = votingDistrictNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}-${keys[3]}-${keys[4]}`);

				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEvent.key) {
						const updatedDistrictChildren = eventItem.children.map((district) => {
							if (district.key == districtNode.key) {
								const updatedConstituencyChildren = district.children.map((constituency) => {
									if (constituency.key == constituencyNode.key) {
										const updatedVotingDistrictChildren = constituency.children.map((votingDistrict) => {
											if (votingDistrict.key == votingDistrictNode.key) {
												const updatedVotingStationChildren = votingDistrict.children.map((votingStation) => {
													if (votingStation.key == votingStationNode.key) {
														// Add polling stations as children of the voting station node
														return {
															...votingStation,
															children: [...(votingStation.children || []), ...pollingStations]
														};
													}
													return votingStation;
												});

												return {
													...votingDistrict,
													children: updatedVotingStationChildren
												};
											}
											return votingDistrict;
										});

										return {
											...constituency,
											children: updatedVotingDistrictChildren
										};
									}
									return constituency;
								});

								return {
									...district,
									children: updatedConstituencyChildren
								};
							}
							return district;
						});

						return {
							...eventItem,
							children: updatedDistrictChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function NationalDelimitationMain(event) {
		if (event.node.data.level == 0) {
			//root / event being expanded
			GetNationalDistricts(event);
		} else if (event.node.data.level == 1) {
			//district
			GetNationalConstituencyByDistrictIdAsync(event);
		} else if (event.node.data.level == 2) {
			//constituency
			GetVotingDistrictByConstituency(event);
		} else if (event.node.data.level == 3) {
			//voting district
			GetVotingStationByVotingDistrictID(event);
		} else if (event.node.data.level == 4) {
			//voting station
			GetPollingStaionByNationalVotingStation(event);
		} else if (event.node.data.level == 5) {
			//village. Not
			//not applicable
		} else if (event.node.data.level == 6) {
			//polling station
			//not applicable to expand
		}
	}
	function GetLocalDistricts(event) {
			setLoading(true);
				delimitationService
			.getLocalDistricts()
			.then((response) => {
				var districts = [];
				setLoading(false);
				response.forEach((e) => {
					districts.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 1,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 1,
							levelName:  changeLang.get("local_delimitation.district")
						},
						leaf: false
					});
				});

				const updatedEvents = events.map((node) => {
					if (node.key == event.node.key) {
						return {
							...node,
							children: [...(node.children || []), ...districts]
						};
					}
					return node;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function GetLocalCouncilsByDistrictIdAsync(event) {
		setLoading(true);
		delimitationService
			.getCouncilsByDistrict(event.node.data.eventDelimitationId)
			.then((response) => {
				var constituencies = [];
				setLoading(false);
				response.forEach((e) => {
					constituencies.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 2,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 2,
							levelName: changeLang.get("local_delimitation.council")
						},
						leaf: false
					});
				});

				var parentEventKey = event.node.key.split("-")[0];
				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEventKey) {
						const updatedChildren = eventItem.children.map((node) => {
							if (node.key == event.node.key) {
								return {
									...node,
									children: [...(node.children || []), ...constituencies]
								};
							}
							return node;
						});

						return {
							...eventItem,
							children: updatedChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function GetLocalVitingDistrictByConstituencID(event) {
		setLoading(true);
		delimitationService
			.GetLocalVotingDistrictsByCouncilIdAsync(event.node.data.eventDelimitationId)
			.then((response) => {
				setLoading(false);
				var votingDistricts = [];
				response.forEach((e) => {
					votingDistricts.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 3,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 3,
							levelName:  changeLang.get("local_delimitation.electoralDivision")
						},
						leaf: false
					});
				});

				var keys = event.node.key.split("-");
				var parentEvent = events.find((x) => x.key == keys[0]); // Find the parent event
				var districtNode = parentEvent.children.find((x) => x.key == `${keys[0]}-${keys[1]}`); // Find the district node

				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEvent.key) {
						const updatedDistrictChildren = eventItem.children.map((node) => {
							if (node.key == districtNode.key) {
								const updatedChildren = node.children.map((childNode) => {
									if (childNode.key == event.node.key) {
										return {
											...childNode,
											children: [...(childNode.children || []), ...votingDistricts]
										};
									}
									return childNode;
								});

								return {
									...node,
									children: updatedChildren
								};
							}
							return node;
						});

						return {
							...eventItem,
							children: updatedDistrictChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function GetLocalVotingStationByVotingDistrict(event) {
		setLoading(true);
		delimitationService
			.GetLocalVotingStationByElectorDivisionIDAsync(event.node.data.eventDelimitationId)
			.then((response) => {
				setLoading(false);
				var VotingStation = [];
				response.forEach((e) => {
					VotingStation.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 4,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 4,
							levelName: changeLang.get("local_delimitation.pollingStation")
						},
						leaf: false
					});
				});

				// setEvents(updatedEvents);
				var keys = event.node.key.split("-");
				var parentEvent = events.find((x) => x.key == keys[0]);
				var districtNode = parentEvent.children.find((x) => x.key == `${keys[0]}-${keys[1]}`);
				var constituencyNode = districtNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}`);

				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEvent.key) {
						const updatedDistrictChildren = eventItem.children.map((district) => {
							if (district.key == districtNode.key) {
								const updatedConstituencyChildren = district.children.map((constituency) => {
									if (constituency.key == constituencyNode.key) {
										const updatedChildNodes = constituency.children.map((node) => {
											if (node.key == event.node.key) {
												return {
													...node,
													children: [...(node.children || []), ...VotingStation]
												};
											}
											return node;
										});

										return {
											...constituency,
											children: updatedChildNodes
										};
									}
									return constituency;
								});

								return {
									...district,
									children: updatedConstituencyChildren
								};
							}
							return district;
						});
						return {
							...eventItem,
							children: updatedDistrictChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function GetPollingStaionByLocalVotingStation(event) {
		setLoading(true);
	
		delimitationService
			.getPollingStaionByLocalVotingStation(event.node.data.eventDelimitationId)
			.then((response) => {
				var pollingStations = [];
				setLoading(false);
				response.forEach((e) => {
					pollingStations.push({
						key: `${event.node.key}-${e.id}`,
						data: {
							parentNodeId: event.node.data.eventID,
							eventDelimitationId: e.id,
							eventDelimitationLevelId: 6,
							eventTypeID: event.node.data.eventTypeID,
							eventID: event.node.data.eventID,
							eventName: event.node.data.name,
							name: e?.code +' - ' + e.name,
							description: e.description,
							isActive: e.isActive,
							eventType: event.node.data.eventType,
							eventCategoryID: event.node.data.eventCategoryID,
							categoryName: event.node.data.categoryName,
							parentEventID: event.node.data.parentEventID,
							level: 6,
							levelName: changeLang.get("local_delimitation.pollingStationDoor")
						},
						leaf: true
					});
				});

				var keys = event.node.key.split("-");
				var parentEvent = events.find((x) => x.key == keys[0]);
				var districtNode = parentEvent.children.find((x) => x.key == `${keys[0]}-${keys[1]}`);
				var constituencyNode = districtNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}`);
				var votingDistrictNode = constituencyNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}-${keys[3]}`);
				var votingStationNode = votingDistrictNode.children.find((x) => x.key == `${keys[0]}-${keys[1]}-${keys[2]}-${keys[3]}-${keys[4]}`);

				const updatedEvents = events.map((eventItem) => {
					if (eventItem.key == parentEvent.key) {
						const updatedDistrictChildren = eventItem.children.map((district) => {
							if (district.key == districtNode.key) {
								const updatedConstituencyChildren = district.children.map((constituency) => {
									if (constituency.key == constituencyNode.key) {
										const updatedVotingDistrictChildren = constituency.children.map((votingDistrict) => {
											if (votingDistrict.key == votingDistrictNode.key) {
												const updatedVotingStationChildren = votingDistrict.children.map((votingStation) => {
													if (votingStation.key == votingStationNode.key) {
														return {
															...votingStation,
															children: [...(votingStation.children || []), ...pollingStations]
														};
													}
													return votingStation;
												});

												return {
													...votingDistrict,
													children: updatedVotingStationChildren
												};
											}
											return votingDistrict;
										});

										return {
											...constituency,
											children: updatedVotingDistrictChildren
										};
									}
									return constituency;
								});

								return {
									...district,
									children: updatedConstituencyChildren
								};
							}
							return district;
						});

						return {
							...eventItem,
							children: updatedDistrictChildren
						};
					}
					return eventItem;
				});

				setEvents(updatedEvents);
			})
			.catch((err) => {setLoading(false);});
	}
	function LocalDelimitationMain(event) {
		if (event.node.data.level == 0) {
			//root / event being expanded
			GetLocalDistricts(event);
		} else if (event.node.data.level == 1) {
			//district
			GetLocalCouncilsByDistrictIdAsync(event);
		} else if (event.node.data.level == 2) {
			//constituency
			GetLocalVitingDistrictByConstituencID(event);
		} else if (event.node.data.level == 3) {
			//voting district
			GetLocalVotingStationByVotingDistrict(event);
		} else if (event.node.data.level == 4) {
			//voting station
			GetPollingStaionByLocalVotingStation(event);
		} else if (event.node.data.level == 5) {
			//village. Not
			//not applicable
		} else if (event.node.data.level == 6) {
			//polling station
			//not applicable to expand
		}
	}
	async function GetAllEvents() {
		setLoading(true);
		try {
			const response = await eventService.getAllEvents({
				EventGroupID: selectedEventGroup?.eventGroupID,
				PageIndex: 1,
				PageSize: 10000
			});

			const formattedEvents = response.map((e) => ({
				key: e.eventID,
				data: {
					eventID: e.eventID,
					eventTypeID: e.eventTypeID,
					eventName: e.name,
					name: e.name,
					description: e.description,
					isActive: e.isActive,
					eventType: e.eventTypeName,
					categoryName: e.eventCategoryName,
					eventCategoryID: e.eventCategoryID,
					parentEventID: e.parentEventID,
					level: 0,
					levelName: "Event"
				},
				leaf: false
			}));

			setEvents(formattedEvents);
			setLoading(false);
		} catch (err) {
			console.error("Error fetching events:", err);
			setLoading(false);
		}
	}
	function CreatePolingStations() {
		setLoading(true);
		delimitationService
			.createPollingStations(pollingStationForm)
			.then((res) => {
				setLoading(false);
				if (res.success) {
					setShowPollingStationsForm(false);
				}
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
				return toast.show({
					severity: "error",
					summary: " Message",
					detail: "There was a tecnical issue processing your request.",
					life: 2000
				});
			});
	}
	const confirmDeleteEvent = (e) => {
			confirmDialog({
				message: "Are you sure you want to deactivate this item?",
				header: "Deactivate Event",
				icon: "pi pi-exclamation-triangle",
				accept: () =>  DeactivateEvent(e),
				reject: () => {}
			});
		};
		function DeactivateEvent(e)
		{
			setLoading(true);
			eventService
				.DeActivateByElection(e.eventID)
				.then((res) => {
					setLoading(false);
					if (res.success) {
						GetAllEvents();
						RefreshSelectedEventGroup(selectedEventGroup?.eventGroupID);
					}
					return toast.show({
						severity: res?.success ? "success" : "error",
						summary: "Message",
						detail: res?.message,
						life: 2000
					});
				})
				.catch((error) => {
					setLoading(false);
					console.error("Error deactivating event:", error);
				})
		}

		const [showuploadSignature,setshowuploadSignature] = useState(false);
		const [uploaded,setUploaded]=useState(false)
		var [signatureForm, setSignatureForm] = useState({
			"BinaryData":"",
			 "FileExt":"", 
			 "ContentType":"",
			 "EventGroupID":selectedEventGroup.eventGroupID
		})
		function CertifyElectionRoll()
		{

			eventService.saveSignature(signatureForm)
			.then((res) => {
				setshowuploadSignature(false);
				if(res?.success)
				{
					RefreshSelectedEventGroup(selectedEventGroup?.eventGroupID)
				}

				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				console.log(err);
				return toast.show({
					severity:  "error",
					summary: "Message",
					detail: "Something went wrong",
					life: 2000
				});

			})

		}

	return (
		<div>
			<ScreenLoader visible={loading} />
			<ConfirmDialog />
			<Dialog
				visible={showuploadSignature}
				onHide={() => setshowuploadSignature(false)}
				header="Certify Voters Register"
				modal
				style={{ width: "30vw", height: "50vh" }}
				footer ={
					<>
						<Button className="p-button-danger" 
						type="button" label="Close" 
						onClick={() => setshowuploadSignature(false)} 
						/>
						<Button 
							disabled={!uploaded} 
							label="Submit" 
							onClick={CertifyElectionRoll}
							className="p-button-success" 
						/>

					</>
				}
			>
				<AddSignature
					setSignatureForm={setSignatureForm}
					signatureForm={signatureForm}
					uploaded={uploaded}
					setUploaded = {setUploaded}
				/>
			</Dialog>
			<Dialog
				visible={showPollingStationsForm}
				onHide={() => setShowPollingStationsForm(false)}
				header={"Create Streams"}
				style={{ width: "50vw", height: "50vh" }}
				footer={
					<>
						<Button className="p-button-danger" type="button" label="Close" onClick={() => setShowPollingStationsForm(false)} />
						<Button label="Submit" onClick={CreatePolingStations} className="p-button-success" icon="pi pi-plus" type="submit" />

					</>
				}
			>
				<ScreenLoader visible={loading} />
				<div className="">
					<div className="grid">
						<div className="col-12  lg:col-4">
							<label>Electors Per Station</label>
							<InputNumber
								style={{ width: "100%" }}
								value={pollingStationForm.electorsPerPollingStation}
								onValueChange={(e) => setPollingStationForm((form) => ({ ...form, electorsPerPollingStation: e.target.value }))}
							/>
						</div>

						<div className="col-12  lg:col-4">
							{/* <label>Sort By</label>
							<Dropdown
								style={{ width: "100%" }}
								optionLabel="Name"
								optionValue="Value"
								onChange={(e) => setPollingStationForm((form) => ({ ...form, sortField: e.target.value }))}
								options={sortOptions}
								value={pollingStationForm.sortField}
								placeholder="Sort Field"
							/> */}
						</div>
					</div>
					<div className="grid">
						{/* <div className="col-12  lg:col-4">
							<label>Sort Ascending</label>
							<Checkbox
								style={{ width: "100%" }}
								checked={pollingStationForm.sortOrderAscending}
								onChange={(e) => setPollingStationForm((form) => ({ ...form, sortOrderAscending: e.target.checked }))}
							/>
						</div> */}
						<div className="col-12  lg:col-4">
							<label>Recreate Polling Stations</label>
							<Checkbox
								style={{ width: "100%" }}
								checked={pollingStationForm.recreate}
								onChange={(e) => setPollingStationForm((form) => ({ ...form, recreate: e.target.checked }))}
							/>
						</div>
						<div className="col-12  lg:col-4">
							<label>Distribute Remainder</label>
							<Checkbox
								style={{ width: "100%" }}
								checked={pollingStationForm.distributeRemainder}
								onChange={(e) => setPollingStationForm((form) => ({ ...form, distributeRemainder: e.target.checked }))}
							/>
						</div>
					</div>
				</div>
			</Dialog>
			<Dialog
				visible={showAddEventForm}
				onHide={() => setshowAddEventForm(false)}
				header={header}
				modal
				style={{ width: "100%", height: "100%" }}
			>
				<AddEvent
					showAddEvent={showAddEventForm}
					setShowAddEvent={setshowAddEventForm}
					setData={selectedEvent}
					eventGroupId={selectedEventGroup?.eventGroupID}
					setEvents={GetAllEvents}
				/>
			</Dialog>
			<Dialog
				visible={showEditEventDelimitationForm}
				onHide={() => setShowEditEventDelimitationForm(false)}
				header="Event Delimitation"
				modal
				style={{ width: "100%", height: "100%" }}
			>
				<EditEventDelimitation
					show={showEditEventDelimitationForm}
					setShow={setShowEditEventDelimitationForm}
					// setData={selectedEvent}
					selectedEvent={selectedEvent}
					setSelectedEvent={setselectedEvent}
					eventGroupId={selectedEventGroup?.eventGroupID}
					GetAllEvents={GetAllEvents}
				/>
			</Dialog>
			<Dialog
				visible={showByElectionEventForm}
				onHide={() => setShowByElectionEventForm(false)}
				header="By Election"
				modal
				style={{ width: "90vw", height: "90vh" }}
			>
				<ByElections
					show={showByElectionEventForm}
					setShow={setShowByElectionEventForm}
					selectedEvent={selectedEvent}
					eventGroupId={selectedEventGroup?.eventGroupID}
				/>
			</Dialog>
			<div>
				<div className="grid my-1">
					<div className="col-12  lg:col-6">
						<TextInput label={<b>Description:</b>} value={groupEventInfo.description} disabled />

					</div>
					<div className="col-12  lg:col-6">
						<TextInput label={<b>Created By:</b>} value={groupEventInfo.createdBy} disabled />
					</div>
				</div>
				<div className="grid col-span-3 relative my-1 lg:mx-1 ">
					{permission?.subModules?.Event?.includes(permissionLookUp.Create) && (
						<div className=" col-span-2 ">
							<Button
								className=" left-0 p-button-success mr-2"
								icon="pi pi-plus"
								label="Add Event"
								onClick={(e) => setshowAddEventForm(true)}
							/>
						</div>
					)}
					{permission?.subModules?.Streams?.includes(permissionLookUp.Create) && (
						<div className=" col-span-2 ">
							<Button
								disabled={selectedEventGroup?.isCertified}
								className=" left-0 p-button-primary mr-2"
								label="Create Streams"
								onClick={(e) => setShowPollingStationsForm(true)}
							/>
						</div>
					)}
					{permission?.subModules?.ElectionDirectorSignature?.includes(permissionLookUp.Create) && (
					<div className="col-span-2">
						<Button 
							label="Certify Voter's Register"
							onClick={(e) => setshowuploadSignature(true)} 
							className="p-button-primary" 
						/>

						</div>
					)}
				</div>
				<TreeTable
					value={events}
					onExpand={(e) => {
						OnTreeExpand(e)}} // Fetch districts when expanded
					// onNodeSelect={(e) => handleNodeClick(e.node)}
					footer={footer}
					tableStyle={{ minWidth: "50rem" }}
					// expandedKeys={expandedKeys}
					resizableColumns
					scrollable
					dataKey="key"
					paginator
					rows={5}
					rowsPerPageOptions={[5, 10, 25]}
					// className="datatable-responsive lg:text-[16px] md:text-[14px] text-[10px]"
					currentPageReportTemplate="Showing {first} to {last} of {totalRecords} events"
					emptyMessage="No event group found."
					columnResizeMode="expand"
					filterDisplay="menu"
					globalFilterFields={["name"]}
				>
					<Column
						field="name"
						header="Name"
						expander
						style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
					></Column>
					<Column field="levelName" header="Level" sortable></Column>
					<Column field="eventType" header="Type" sortable />
					<Column
						sortable
						field="isActive"
						header="Status"
						body={(e) => {
							const parent = events.find((ev) => ev.key === e.data.parentNodeId);
							const isActive = e.data.isActive == 1 || (parent && parent.data.isActive == 1);
							return isActive ? (
								<Button label="Active" className="p-button-success p-button-rounded" style={{ height: "30px" }} />
							) : (
								<Button label="Not Active" className="p-button-danger p-button-rounded" style={{ height: "30px" }} />
							);
						}}
					/>
					<Column
						header="Actions"
						body={(rowData) => {
							const parent = events.find((ev) => ev.key === rowData.data.parentNodeId);
							const isActive = rowData.data.isActive == 1 || (parent && parent.data.isActive == 1);

							return (
								<>
									<div className="flex gap-1">
										{permission?.subModules?.Event?.includes(permissionLookUp.Update) && (
											<Button
												tooltip="Click to Edit"
												type="button"
												icon="pi pi-pencil"
												severity="success"
												rounded
												onClick={() => {
													setselectedEvent(rowData.data);
													setShowEditEventDelimitationForm(true);
												}}
											/>
										)}
										{permission?.subModules?.ByElectionEvent?.includes(permissionLookUp.Read) && (
											<Button
												type="button"
												icon="pi pi-arrow-right-arrow-left"
												rounded
												disabled={isNational? rowData.data.level != 2 : rowData.data.level != 3}
												tooltip="By-Election"
												onClick={() => {
													setselectedEvent(rowData.data);
													setShowByElectionEventForm(true);
												}}
											/>
										)}
										{permission?.subModules?.Event?.includes(permissionLookUp.Delete) && (
											<Button
												disabled={rowData.data.level != 0 && !isActive}
												type="button"
												icon="pi pi-times"
												severity="danger"
												rounded
												tooltip="Click Deactivate"
												onClick={() => {
													handleDeactivate(rowData?.data);
												}}
											/>
										)}
									</div>
								</>
							);
						}}
					/>
				</TreeTable>
			</div>
		</div>
	);
}
